import React from 'react';
const FlagSVG = ({ color = 'white', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M0.55814 0C0.866389 0 1.11628 0.24989 1.11628 0.55814V1.93488L2.39678 1.67879C3.62508 1.43312 4.89831 1.55002 6.06132 2.01523L6.36889 2.13826C7.42928 2.5624 8.59632 2.64161 9.70426 2.36462C10.1738 2.24723 10.5509 2.75617 10.3019 3.17122L9.35047 4.75699C9.09633 5.18055 8.96923 5.39233 8.93909 5.62269C8.92659 5.71878 8.92659 5.8161 8.93909 5.91219C8.96923 6.14255 9.09633 6.35433 9.35047 6.7779L10.5119 8.7136C10.7431 9.09909 10.5363 9.59851 10.1002 9.70753L10.0257 9.72614C8.70876 10.0554 7.32167 9.96123 6.06132 9.45712C4.89831 8.99185 3.62508 8.87501 2.39678 9.12067L1.11628 9.37674V15.4419C1.11628 15.7501 0.866389 16 0.55814 16C0.24989 16 0 15.7501 0 15.4419V0.55814C0 0.24989 0.24989 0 0.55814 0Z"
        fill="white"
      />
    </svg>
  );
};

export default FlagSVG;
